// Lista de países com indicativo telefónico (ISO 3166 + E.164 dial codes).
export const COUNTRIES = [
  { n: 'Afeganistão', c: 'AF', d: '+93' }, { n: 'África do Sul', c: 'ZA', d: '+27' },
  { n: 'Albânia', c: 'AL', d: '+355' }, { n: 'Alemanha', c: 'DE', d: '+49' },
  { n: 'Andorra', c: 'AD', d: '+376' }, { n: 'Angola', c: 'AO', d: '+244' },
  { n: 'Anguila', c: 'AI', d: '+1264' }, { n: 'Antígua e Barbuda', c: 'AG', d: '+1268' },
  { n: 'Arábia Saudita', c: 'SA', d: '+966' }, { n: 'Argélia', c: 'DZ', d: '+213' },
  { n: 'Argentina', c: 'AR', d: '+54' }, { n: 'Arménia', c: 'AM', d: '+374' },
  { n: 'Aruba', c: 'AW', d: '+297' }, { n: 'Austrália', c: 'AU', d: '+61' },
  { n: 'Áustria', c: 'AT', d: '+43' }, { n: 'Azerbaijão', c: 'AZ', d: '+994' },
  { n: 'Bahamas', c: 'BS', d: '+1242' }, { n: 'Bangladeche', c: 'BD', d: '+880' },
  { n: 'Barbados', c: 'BB', d: '+1246' }, { n: 'Barém', c: 'BH', d: '+973' },
  { n: 'Bélgica', c: 'BE', d: '+32' }, { n: 'Belize', c: 'BZ', d: '+501' },
  { n: 'Benim', c: 'BJ', d: '+229' }, { n: 'Bermudas', c: 'BM', d: '+1441' },
  { n: 'Bielorrússia', c: 'BY', d: '+375' }, { n: 'Bolívia', c: 'BO', d: '+591' },
  { n: 'Bósnia e Herzegovina', c: 'BA', d: '+387' }, { n: 'Botsuana', c: 'BW', d: '+267' },
  { n: 'Brasil', c: 'BR', d: '+55' }, { n: 'Brunei', c: 'BN', d: '+673' },
  { n: 'Bulgária', c: 'BG', d: '+359' }, { n: 'Burquina Faso', c: 'BF', d: '+226' },
  { n: 'Burúndi', c: 'BI', d: '+257' }, { n: 'Butão', c: 'BT', d: '+975' },
  { n: 'Cabo Verde', c: 'CV', d: '+238' }, { n: 'Camarões', c: 'CM', d: '+237' },
  { n: 'Camboja', c: 'KH', d: '+855' }, { n: 'Canadá', c: 'CA', d: '+1' },
  { n: 'Catar', c: 'QA', d: '+974' }, { n: 'Cazaquistão', c: 'KZ', d: '+7' },
  { n: 'Chade', c: 'TD', d: '+235' }, { n: 'Chile', c: 'CL', d: '+56' },
  { n: 'China', c: 'CN', d: '+86' }, { n: 'Chipre', c: 'CY', d: '+357' },
  { n: 'Colômbia', c: 'CO', d: '+57' }, { n: 'Comores', c: 'KM', d: '+269' },
  { n: 'Congo (Brazzaville)', c: 'CG', d: '+242' }, { n: 'Congo (RDC)', c: 'CD', d: '+243' },
  { n: 'Coreia do Norte', c: 'KP', d: '+850' }, { n: 'Coreia do Sul', c: 'KR', d: '+82' },
  { n: 'Costa do Marfim', c: 'CI', d: '+225' }, { n: 'Costa Rica', c: 'CR', d: '+506' },
  { n: 'Croácia', c: 'HR', d: '+385' }, { n: 'Cuba', c: 'CU', d: '+53' },
  { n: 'Dinamarca', c: 'DK', d: '+45' }, { n: 'Domínica', c: 'DM', d: '+1767' },
  { n: 'Egito', c: 'EG', d: '+20' }, { n: 'Emirados Árabes Unidos', c: 'AE', d: '+971' },
  { n: 'Equador', c: 'EC', d: '+593' }, { n: 'Eritreia', c: 'ER', d: '+291' },
  { n: 'Eslováquia', c: 'SK', d: '+421' }, { n: 'Eslovénia', c: 'SI', d: '+386' },
  { n: 'Espanha', c: 'ES', d: '+34' }, { n: 'Estados Unidos', c: 'US', d: '+1' },
  { n: 'Estónia', c: 'EE', d: '+372' }, { n: 'Etiópia', c: 'ET', d: '+251' },
  { n: 'Fiji', c: 'FJ', d: '+679' }, { n: 'Filipinas', c: 'PH', d: '+63' },
  { n: 'Finlândia', c: 'FI', d: '+358' }, { n: 'França', c: 'FR', d: '+33' },
  { n: 'Gabão', c: 'GA', d: '+241' }, { n: 'Gâmbia', c: 'GM', d: '+220' },
  { n: 'Gana', c: 'GH', d: '+233' }, { n: 'Geórgia', c: 'GE', d: '+995' },
  { n: 'Gibraltar', c: 'GI', d: '+350' }, { n: 'Granada', c: 'GD', d: '+1473' },
  { n: 'Grécia', c: 'GR', d: '+30' }, { n: 'Gronelândia', c: 'GL', d: '+299' },
  { n: 'Guadalupe', c: 'GP', d: '+590' }, { n: 'Guame', c: 'GU', d: '+1671' },
  { n: 'Guatemala', c: 'GT', d: '+502' }, { n: 'Guiana', c: 'GY', d: '+592' },
  { n: 'Guiné', c: 'GN', d: '+224' }, { n: 'Guiné Equatorial', c: 'GQ', d: '+240' },
  { n: 'Guiné-Bissau', c: 'GW', d: '+245' }, { n: 'Haiti', c: 'HT', d: '+509' },
  { n: 'Honduras', c: 'HN', d: '+504' }, { n: 'Hong Kong', c: 'HK', d: '+852' },
  { n: 'Hungria', c: 'HU', d: '+36' }, { n: 'Iémen', c: 'YE', d: '+967' },
  { n: 'Ilhas Caimão', c: 'KY', d: '+1345' }, { n: 'Ilhas Faroé', c: 'FO', d: '+298' },
  { n: 'Ilhas Marshall', c: 'MH', d: '+692' }, { n: 'Ilhas Salomão', c: 'SB', d: '+677' },
  { n: 'Ilhas Virgens Britânicas', c: 'VG', d: '+1284' }, { n: 'Índia', c: 'IN', d: '+91' },
  { n: 'Indonésia', c: 'ID', d: '+62' }, { n: 'Irão', c: 'IR', d: '+98' },
  { n: 'Iraque', c: 'IQ', d: '+964' }, { n: 'Irlanda', c: 'IE', d: '+353' },
  { n: 'Islândia', c: 'IS', d: '+354' }, { n: 'Israel', c: 'IL', d: '+972' },
  { n: 'Itália', c: 'IT', d: '+39' }, { n: 'Jamaica', c: 'JM', d: '+1876' },
  { n: 'Japão', c: 'JP', d: '+81' }, { n: 'Jordânia', c: 'JO', d: '+962' },
  { n: 'Kosovo', c: 'XK', d: '+383' }, { n: 'Kuwait', c: 'KW', d: '+965' },
  { n: 'Laos', c: 'LA', d: '+856' }, { n: 'Lesoto', c: 'LS', d: '+266' },
  { n: 'Letónia', c: 'LV', d: '+371' }, { n: 'Líbano', c: 'LB', d: '+961' },
  { n: 'Libéria', c: 'LR', d: '+231' }, { n: 'Líbia', c: 'LY', d: '+218' },
  { n: 'Listenstaine', c: 'LI', d: '+423' }, { n: 'Lituânia', c: 'LT', d: '+370' },
  { n: 'Luxemburgo', c: 'LU', d: '+352' }, { n: 'Macau', c: 'MO', d: '+853' },
  { n: 'Macedónia do Norte', c: 'MK', d: '+389' }, { n: 'Madagáscar', c: 'MG', d: '+261' },
  { n: 'Malásia', c: 'MY', d: '+60' }, { n: 'Maláui', c: 'MW', d: '+265' },
  { n: 'Maldivas', c: 'MV', d: '+960' }, { n: 'Mali', c: 'ML', d: '+223' },
  { n: 'Malta', c: 'MT', d: '+356' }, { n: 'Marrocos', c: 'MA', d: '+212' },
  { n: 'Maurícia', c: 'MU', d: '+230' }, { n: 'Mauritânia', c: 'MR', d: '+222' },
  { n: 'México', c: 'MX', d: '+52' }, { n: 'Mianmar', c: 'MM', d: '+95' },
  { n: 'Micronésia', c: 'FM', d: '+691' }, { n: 'Moçambique', c: 'MZ', d: '+258' },
  { n: 'Moldávia', c: 'MD', d: '+373' }, { n: 'Mónaco', c: 'MC', d: '+377' },
  { n: 'Mongólia', c: 'MN', d: '+976' }, { n: 'Montenegro', c: 'ME', d: '+382' },
  { n: 'Namíbia', c: 'NA', d: '+264' }, { n: 'Nepal', c: 'NP', d: '+977' },
  { n: 'Nicarágua', c: 'NI', d: '+505' }, { n: 'Níger', c: 'NE', d: '+227' },
  { n: 'Nigéria', c: 'NG', d: '+234' }, { n: 'Noruega', c: 'NO', d: '+47' },
  { n: 'Nova Zelândia', c: 'NZ', d: '+64' }, { n: 'Omã', c: 'OM', d: '+968' },
  { n: 'Países Baixos', c: 'NL', d: '+31' }, { n: 'Palau', c: 'PW', d: '+680' },
  { n: 'Palestina', c: 'PS', d: '+970' }, { n: 'Panamá', c: 'PA', d: '+507' },
  { n: 'Papua-Nova Guiné', c: 'PG', d: '+675' }, { n: 'Paquistão', c: 'PK', d: '+92' },
  { n: 'Paraguai', c: 'PY', d: '+595' }, { n: 'Peru', c: 'PE', d: '+51' },
  { n: 'Polinésia Francesa', c: 'PF', d: '+689' }, { n: 'Polónia', c: 'PL', d: '+48' },
  { n: 'Porto Rico', c: 'PR', d: '+1787' }, { n: 'Portugal', c: 'PT', d: '+351' },
  { n: 'Quénia', c: 'KE', d: '+254' }, { n: 'Quirguistão', c: 'KG', d: '+996' },
  { n: 'Reino Unido', c: 'GB', d: '+44' }, { n: 'República Centro-Africana', c: 'CF', d: '+236' },
  { n: 'República Checa', c: 'CZ', d: '+420' }, { n: 'República Dominicana', c: 'DO', d: '+1809' },
  { n: 'Roménia', c: 'RO', d: '+40' }, { n: 'Ruanda', c: 'RW', d: '+250' },
  { n: 'Rússia', c: 'RU', d: '+7' }, { n: 'Samoa', c: 'WS', d: '+685' },
  { n: 'San Marino', c: 'SM', d: '+378' }, { n: 'Santa Lúcia', c: 'LC', d: '+1758' },
  { n: 'São Cristóvão e Neves', c: 'KN', d: '+1869' }, { n: 'São Tomé e Príncipe', c: 'ST', d: '+239' },
  { n: 'São Vicente e Granadinas', c: 'VC', d: '+1784' }, { n: 'Seicheles', c: 'SC', d: '+248' },
  { n: 'Senegal', c: 'SN', d: '+221' }, { n: 'Serra Leoa', c: 'SL', d: '+232' },
  { n: 'Sérvia', c: 'RS', d: '+381' }, { n: 'Singapura', c: 'SG', d: '+65' },
  { n: 'Síria', c: 'SY', d: '+963' }, { n: 'Somália', c: 'SO', d: '+252' },
  { n: 'Sri Lanka', c: 'LK', d: '+94' }, { n: 'Suazilândia (Essuatíni)', c: 'SZ', d: '+268' },
  { n: 'Sudão', c: 'SD', d: '+249' }, { n: 'Sudão do Sul', c: 'SS', d: '+211' },
  { n: 'Suécia', c: 'SE', d: '+46' }, { n: 'Suíça', c: 'CH', d: '+41' },
  { n: 'Suriname', c: 'SR', d: '+597' }, { n: 'Tailândia', c: 'TH', d: '+66' },
  { n: 'Taiwan', c: 'TW', d: '+886' }, { n: 'Tajiquistão', c: 'TJ', d: '+992' },
  { n: 'Tanzânia', c: 'TZ', d: '+255' }, { n: 'Timor-Leste', c: 'TL', d: '+670' },
  { n: 'Togo', c: 'TG', d: '+228' }, { n: 'Tonga', c: 'TO', d: '+676' },
  { n: 'Trindade e Tobago', c: 'TT', d: '+1868' }, { n: 'Tunísia', c: 'TN', d: '+216' },
  { n: 'Turcomenistão', c: 'TM', d: '+993' }, { n: 'Turquia', c: 'TR', d: '+90' },
  { n: 'Ucrânia', c: 'UA', d: '+380' }, { n: 'Uganda', c: 'UG', d: '+256' },
  { n: 'Uruguai', c: 'UY', d: '+598' }, { n: 'Usbequistão', c: 'UZ', d: '+998' },
  { n: 'Vanuatu', c: 'VU', d: '+678' }, { n: 'Vaticano', c: 'VA', d: '+379' },
  { n: 'Venezuela', c: 'VE', d: '+58' }, { n: 'Vietname', c: 'VN', d: '+84' },
  { n: 'Zâmbia', c: 'ZM', d: '+260' }, { n: 'Zimbabué', c: 'ZW', d: '+263' },
];

export const flagEmoji = (iso2) => {
  if (!iso2 || iso2.length !== 2) return '🏳️';
  return String.fromCodePoint(...[...iso2.toUpperCase()].map(ch => 0x1f1e6 + ch.charCodeAt(0) - 65));
};
